import HeaderTitle from '../../../../../../common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { cn } from '../../../../../../common-utils/libraries/tailwind/utils';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '../../../../../../common-utils/components/ui/modal';
import FooterForm from '../../../../../../common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '../../../../../../common-utils/components/renders/entity/Entity';
import actionsUsers from '@/app/modules/users/monetic/api/actionsUsers';
import { useState } from 'react';
import { nsUser } from '@/app/i18n/namespaces';
import PropTypes from 'prop-types';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalRemoveUser Component
 */
function ModalRemoveUser({ trigger, isOpen, setIsOpen, userId, userEmail, setLaunchRefetch }) {

    // State
    const [bodyContent, setBodyContent] = useState(
        <>
            <Entity entity={'modal.remove_user.text'} namespace={nsUser} />
            <div className='my-4'>{userEmail}</div>
            <Entity entity={'modal.remove_user.warning'} namespace={nsUser} />
        </>
    );
    const [showSubmitButton, setShowSubmitButton] = useState(true);

    // API Calls
    const onSuccess = () => {
        setShowSubmitButton(false);
        setBodyContent(<Entity entity={'modal.remove_user.success'} namespace={nsUser} data={{ userEmail: userEmail }} />);
    };
    const onError = () => {
        setShowSubmitButton(false);
        setBodyContent(<Entity entity={'modal.remove_user.error'} namespace={nsUser} />);
    };
    const submitResetPassword = actionsUsers.removeUser(onSuccess, onError);

    const onClose = () => {
        setIsOpen(false);
        if (submitResetPassword.isSuccess) {
            setLaunchRefetch(true);
        }
    };

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.remove_user.title'} namespace={nsUser} />
            <ModalBody>
                {bodyContent}
            </ModalBody>
            <FooterForm
                onSubmit={() => submitResetPassword.mutate(userId)}
                isSubmitting={submitResetPassword.isLoading}
                showSubmitButton={showSubmitButton}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={onClose}>
            {content}
        </Modal>
    );
}

ModalRemoveUser.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    userId: PropTypes.string.isRequired,
    userEmail: PropTypes.string.isRequired,
    setLaunchRefetch: PropTypes.func
};

export default ModalRemoveUser;